import { PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const BoldText = (
  props: PropsWithChildren<{ className?: string }>
): JSX.Element => (
  <span className={cn(styles.boldText, props.className)}>{props.children}</span>
);
